module.exports = __webpack_public_path__ + "img/Backshop.0981b858.jpg";